import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { theme } from '../../styles/theme';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-out forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: slideIn 0.3s ease-out forwards;

  @keyframes slideIn {
    from {
      transform: scale(0.8) translateY(-20px);
      opacity: 0;
    }
    to {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: ${props => props.theme.colors.primary};
  cursor: pointer;
  font-size: 1.5rem;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transform: scale(1.1);
  }
`;

const Icon = styled.div`
  font-size: 3rem;
  color: ${props => props.theme.colors.accent};
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-family: ${props => props.theme.fonts.main};
  font-size: 1.2rem;
  color: ${props => props.theme.colors.primary};
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ClosurePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenShown, setHasBeenShown] = useState(false);

  useEffect(() => {
    // Check if popup has already been shown in this session
    const popupShown = sessionStorage.getItem('castleClosurePopupOct2025');
    if (popupShown) {
      setHasBeenShown(true);
      return;
    }

    // Show closure notice on 16th October 2025
    const today = new Date();
    const isCastleClosed = today.getFullYear() === 2025 &&
                           today.getMonth() === 9 && // October is month 9 (0-based)
                           today.getDate() === 16;

    if (isCastleClosed && !hasBeenShown) {
      setIsVisible(true);
    }
  }, [hasBeenShown]);

  const handleClose = () => {
    setIsVisible(false);
    setHasBeenShown(true);
    // Remember that popup was shown for this session
    sessionStorage.setItem('castleClosurePopupOct2025', 'true');
  };

  if (!isVisible || hasBeenShown) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Icon>
          <FontAwesomeIcon icon={faInfoCircle} />
        </Icon>
        <Title>Castle Closed</Title>
        <Message>
Belvoir Castle is closed on Thursday 16th October 2025 due to a private event.
<br /><br />
The Gardens and Adventure Playground remain open as usual.
<br /><br />
We apologise for any inconvenience.
</Message>

      </ModalContent>
    </ModalOverlay>
  );
};

export default ClosurePopup; 